module.exports = "/images/helpImg.svg";